import type { NativeStackScreenProps } from "@react-navigation/native-stack";
import type { NavigationProp } from "@react-navigation/native";
import { useTranslations } from "@src/packages/i18n";
import type { YouStackParamList } from "../../../types";
import type { RootStackParamList } from "../../../../App";
import { useYouScreen } from "../YouScreenContext";
import MedicalFertilityDetail from "../sections/MedicalFertilityDetail";
import type { MedicalFertilityDestination } from "../sections/CareContext";
import YouDetailScreenLayout from "../components/YouDetailScreenLayout";
import { useSmartBack } from "../../../hooks/useSmartBack";

type Props = NativeStackScreenProps<
  YouStackParamList,
  "MedicalFertilityDetail"
>;

export default function MedicalFertilityDetailScreen({ navigation }: Props) {
  const handleBack = useSmartBack({
    fallbackTab: "Profile",
    fallbackScreen: "YouOverview",
  });
  const t = useTranslations();
  const { personalMedical } = useYouScreen();
  const rootNavigation =
    navigation.getParent<NavigationProp<RootStackParamList>>()!;

  const navigateMedicalCare = (destination: MedicalFertilityDestination) => {
    if (destination.screen === "Documents") {
      rootNavigation.navigate("Home", {
        screen: "Care",
        params: {
          screen: "Documents",
          params: destination.params,
        },
      });
      return;
    }
    rootNavigation.navigate("Home", {
      screen: "Care",
      params: { screen: destination.screen },
    });
  };

  return (
    <YouDetailScreenLayout
      title={t("you.panel_titles.medical_fertility")}
      onBack={handleBack}
    >
      <MedicalFertilityDetail
        personalMedical={personalMedical}
        onNavigate={navigateMedicalCare}
      />
    </YouDetailScreenLayout>
  );
}
